var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoRecording = function SvgVideoRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: 1.5,
    d: "M20.75 11.287V10c0-.964-.786-1.75-1.75-1.75H7c-.964 0-1.75.786-1.75 1.75v10c0 .964.786 1.75 1.75 1.75h12c.964 0 1.75-.786 1.75-1.75v-1.287l2.915 1.458 1.085.543V9.285l-1.085.543z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 1.5,
    y: 1.5,
    stroke: "currentcolor",
    strokeDasharray: "3 4",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    rx: 1.5
  })));
};
export default SvgVideoRecording;